export default "__VITE_ASSET__9898dc57__"